// @ts-expect-error Could not find a declaration file for module
import Client from 'ads-account-connection/data/Client';
import PortalIdParser from 'PortalIdParser';
export const getHubs2Info = () => {
  const PORTAL_ID = PortalIdParser.get();
  return Client.apiRequest(`hubs2/v1/info/hub/${PORTAL_ID}`);
};